import React, { useEffect, useState } from 'react'
import { t } from '../../../utils/i18n'
import { useAuth } from '../../../customHooks/useAuth'
import { BUSINESS_DETAILS } from '../../../constants/routes'
import axios from '../../../utils/axios'
import CustomTable, { TableColumn } from '../../molecules/table/table'
import { mapTokenHealthTableData } from '../../../containers/utils'
import { CanBeAnything } from '../../../types'
import { InfoTooltip } from '../../atoms/info-tooltip/info-tooltip'
import './token-health.scss'

interface TokenHealthProps {
  businessId: string
}

const tokenCols: TableColumn[] = [
  {
    key: 'category',
    label: t('token.health.col.category'),
    fixed: true,
    align: 'left',
    flexGrow: 1,
    toolTipContent:
      'App integrations are grouped by OneSocial Categories (Predict, Activate, Optimize). Only integrations active for this BM appear here.',
  },
  {
    key: 'name',
    label: t('token.health.col.name'),
    fixed: true,
    align: 'left',
    flexGrow: 1,
    toolTipContent: 'Name of the token.',
  },
  {
    key: 'customToken',
    label: t('token.health.col.customToken'),
    fixed: true,
    align: 'left',
    flexGrow: 1,
    toolTipContent: 'Yes indicates a manually overridden token instead of the default UPA token.',
  },
  {
    key: 'tokenStatus',
    label: t('token.health.col.tokenStatus'),
    fixed: true,
    align: 'left',
    flexGrow: 1,
    toolTipContent: 'Shows token validity (Healthy, Warning, or Error)',
  },
  {
    key: 'lastChecked',
    label: t('token.health.col.lastChecked'),
    fixed: true,
    align: 'left',
    flexGrow: 1,
    toolTipContent: 'Timestamp when the token status was last verified.',
  },
]
export const TokenHealth = ({ businessId }: TokenHealthProps) => {
  const { user } = useAuth()
  const [tokenTableData, setTokenTableData] = useState<CanBeAnything[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const callTokenHealthAPI = async (businessId: string) => {
    try {
      setIsLoading(true)
      const config = {
        method: 'GET',
        url: `${BUSINESS_DETAILS}/${businessId}/tokenHealth`,
        headers: user?.isSSO
          ? {
              'x-user': user?.email,
              'x-access-token': user?.tokens?.accessToken?.token,
              'x-source': 'sso',
            }
          : {
              'x-user': user?.email,
              'x-access-token': user?.tokens?.accessToken?.token,
            },
      }

      const res = await axios(config)
      setTokenTableData(mapTokenHealthTableData(res?.data?.data))
    } catch (err) {
      console.error('Failed to fetch token health data', err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    callTokenHealthAPI(businessId)
  }, [businessId])
  return (
    <div className="token-health-container">
      <div className="token-health-heading">
        <h2>{t('token-status')}</h2>
        <InfoTooltip
          styleClass="input-info"
          tooltipContent={
            'This field displays status only for custom tokens. Default UPA token errors are tracked under sync statuses'
          }
          placement={'right'}
        />
      </div>
      <CustomTable data={tokenTableData} columns={tokenCols} isLoading={isLoading} rowHeight={42} />
    </div>
  )
}
